export const COLUMN_WIDTH_MIN = 120
export const COLUMN_WIDTH_MAX = 400

export function estimateTextPx(text: string, cjkPx: number, asciiPx: number): number {
  let width = 0
  for (const ch of text) {
    const code = ch.codePointAt(0) ?? 0
    const isWide = code > 0x2e7f || (code >= 0x00a1 && code <= 0x00ff)
    width += isWide ? cjkPx : asciiPx
  }
  return width
}

export function estimateColumnWidth(headerName: string, sampleValues: unknown[]): number {
  // 80 はソートアイコン+gap+フィルタアイコン+padding の実測（約78px）に基づく。
  // 不足すると最終カラム（min-width/max-width で幅が固定される）でフィルタアイコンがはみ出す
  const headerWidth = estimateTextPx(headerName, 14, 8) + 80
  let maxContentPx = 0
  for (const v of sampleValues) {
    if (v === null || v === undefined) continue
    const px = estimateTextPx(String(v), 14, 8)
    if (px > maxContentPx) maxContentPx = px
  }
  const contentWidth = maxContentPx + 24
  return Math.max(
    COLUMN_WIDTH_MIN,
    Math.min(COLUMN_WIDTH_MAX, Math.max(headerWidth, contentWidth)),
  )
}
